// import {Avatar} from 'antd'
import {Tag} from 'common/components'
import './Panel.scss'

interface PanelProps {
  img: string
  title: string
  tag?: string
}

export default function Panel({img, title, tag}: PanelProps) {
  return (
    <div className="Panel">
      {/* <Avatar className="Panel-Avatar" src={img} size={76} alt={title} /> */}
      <h2 className="Panel-Title">
        <Tag variant='title' size='large' color="charcoal">{title}</Tag>
        { !!tag &&
          <Tag color="danger" variant="round">{tag}</Tag>
        }
      </h2>
    </div>
  )
}
